// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";

Rails.start();
import "bootstrap";
import AOS from "aos";
import landKitNavbarInit from "../src/frontend/landkit/navbar";
import landKitDropdownInit from "../src/frontend/landkit/dropdown";
require("@fancyapps/fancybox");
require("@fancyapps/fancybox/dist/jquery.fancybox.css");
// Copies every image under ../images into the build, for image_pack_tag in views
require.context("../images", true);

import "../stylesheets/frontend";

jQuery(function () {
  AOS.init({ once: true });
  landKitNavbarInit();
  landKitDropdownInit();

  $().fancybox({
    selector: ".attachment--preview a",

    caption: function (_instance, _item) {
      return $(this).parent().find("figcaption").text();
    },
  });
});
